"use client";

import { useEffect } from "react";

export function PwaRegister() {
  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/sw.js")
          .then((registration) => {
            console.log("j/slash PWA ServiceWorker registered with scope:", registration.scope);
          })
          .catch((err) => {
            console.warn("j/slash PWA ServiceWorker registration skipped/failed:", err);
          });
      });
    }
  }, []);

  return null;
}
